import {css} from 'aphrodite';
import React from 'react';

import {getAccessibleOrInaccessibleId, isInaccessible} from 'graphql-client/InaccessibleInfo';
import ProcedurePageLinkForProcedureRun from 'procedures/ProcedurePageLinkForProcedureRun';
import getProcedureReplicateName from 'procedures/utils/getProcedureReplicateNames';
import getProcedureRunConditionName from 'procedures/utils/getProcedureRunConditionNames';
import {UpdateTaskParams} from 'processes/process-task-details/utils/updateTaskDetailsTask';
import BenchChip from 'ui-library/chips/BenchChip';
import {ChipSize} from 'ui-library/chips/Chip';

import FormattedTextField from '../fields/FormattedTextField';
import PlaceholderFieldValue from '../fields/PlaceholderFieldValue';
import {
  getProcedureStepTaskDetailsSummaryRows,
  ProcedureMethodTaskField,
} from '../procedures/getProcedureStepTaskDetailsSections';
import {
  ProcessTaskDetailsRowContent,
  PROCESS_TASK_DETAILS_PAGE_STYLES,
  getProcessTaskDetailsLabels,
  ProcessTaskGql,
} from '../ProcessTaskDetailsPageConstants';

export function getRecipeStepTaskDetailsSummaryRows(
  processTask: ProcessTaskGql,
  onUpdateTask: (updatedTask: UpdateTaskParams) => Promise<void>
): Array<ProcessTaskDetailsRowContent> {
  let methodExecutionInstance = null;
  let conditionReplicateRunTask = null;
  let procedureRun = null;
  let conditionsDisplayString = null;
  let replicateDisplayString = null;

  if (
    processTask.procedureStepExecutionInstance != null &&
    !isInaccessible(processTask.procedureStepExecutionInstance)
  ) {
    methodExecutionInstance = processTask.procedureStepExecutionInstance?.methodExecutionInstance;
  }
  if (methodExecutionInstance != null && !isInaccessible(methodExecutionInstance)) {
    conditionReplicateRunTask = methodExecutionInstance?.procedureRunConditionReplicate?.processRootTask;
    conditionsDisplayString = getProcedureRunConditionName(methodExecutionInstance);
    procedureRun = methodExecutionInstance?.procedureRun;
    replicateDisplayString = getProcedureReplicateName(methodExecutionInstance);
  }

  const processTaskDetailsLabels = getProcessTaskDetailsLabels();

  return getProcedureStepTaskDetailsSummaryRows(processTask, onUpdateTask, {
    experimentRunContent: {
      label: processTaskDetailsLabels.RECIPE_CONDITION_REPLICATE_RUN,
      component:
        conditionReplicateRunTask != null ? (
          <BenchChip
            id={getAccessibleOrInaccessibleId(conditionReplicateRunTask)}
            className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.chipHeight)}
            size={ChipSize.TABLE_CELL}
          />
        ) : (
          <PlaceholderFieldValue />
        ),
    },
    unitOperationContent: {
      label: processTaskDetailsLabels.RECIPE_UNIT_OPERATION,
      component: <ProcedureMethodTaskField processTask={processTask} />,
    },
    procedureTemplateContent: {
      label: processTaskDetailsLabels.RECIPE_TEMPLATE,
      component:
        procedureRun != null ? (
          <ProcedurePageLinkForProcedureRun
            procedureRun={procedureRun}
            className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.rowHeight)}
          />
        ) : (
          <PlaceholderFieldValue />
        ),
    },
    conditionsContent: {
      label: processTaskDetailsLabels.RECIPE_CONDITIONS,
      component: conditionsDisplayString ? (
        <FormattedTextField text={conditionsDisplayString} />
      ) : (
        <PlaceholderFieldValue />
      ),
    },
    replicatesContent: {
      label: processTaskDetailsLabels.RECIPE_REPLICATE,
      component: replicateDisplayString ? (
        <FormattedTextField text={replicateDisplayString} />
      ) : (
        <PlaceholderFieldValue />
      ),
    },
  });
}
